import styled from "styled-components";


export const StyleWelcome = styled.h1`
    display: block;
    font-size: 2.5rem;
    color: aqua;
    margin-bottom: 20px;
    text-align: center;
    margin-top: 80px;

    span{
        color: #08A1E4;
    }

    @media (max-width: 790px){
        font-size: 1.5rem;
    }
`